import Consolidation from "./Consolidation";
export default Consolidation;
